import React, {Component} from 'react';
import {Scatter} from 'react-chartjs-2';
import PropTypes from 'prop-types';
import {Strings} from "../Strings";
import {Constants} from "../Constants";

export class CavitationChart extends Component {
    constructor(props) {
        super(props);

        this.baseDataset = [
            {
                label: "line",
                data: [{x: 0, y: 2}, {x: 5.5, y: 16}],
                fill: "end",
                pointRadius: 0,
                showLine: true,
                borderColor: Constants.avkBlue,
                backgroundColor: Constants.cavitationChartDangerColor,
            }];
        this.options = {
            events: [],
            tooltips: {
                enabled: false
            },
            defaultFontFamily: Constants.chartFontFamily,
            legend: {
                display: false
            },
            title: {
                display: false,
                text: Strings.titleCavitationChart
            },
            scales: {
                xAxes: [{
                    position: 'bottom',
                    scaleLabel: {
                        display: true,
                        labelString: Strings.cavitationChartX
                    },
                    ticks: {
                        min: 0,
                        max: 8,
                        stepSize: 1
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: Strings.cavitationChartY
                    },
                    ticks: {
                        min: 0,
                        max: 16,
                        stepSize: 2,
                        minor: {
                            display: true
                        }
                    }
                }]
            },
            plugins: {
                datalabels: {
                    display: false
                }
            },
        };
    }

    render() {

        let newDataset = this.baseDataset.slice(0);
        newDataset.unshift(
            {
                label: "Cavitation point",
                data: [{x: this.props.inputData.outletPressure, y: this.props.inputData.inletPressure}],
                pointBackgroundColor: Constants.avkBlue,
                pointBorderColor: Constants.capChartBorderColor,
                pointBorderWidth: Constants.cavChartPointBorderWidth,
                pointRadius: Constants.cavChartPointRadius,
            });
        return <div className="botSpace">
            <h2>{Strings.titleCavitationChart}</h2>
            <div className="block cavChart d-flex flex-column align-items-center"><Scatter data={{datasets: newDataset}} options={this.options}
                                            width={Constants.cavChartRatio[0]} height={Constants.cavChartRatio[1]}/>
            </div>
        </div>
    }
}

CavitationChart.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired
};